module.exports = __webpack_public_path__ + "media/icons/check-015d4dc532a93116aa0aea395e7627e9.svg";